import { languages, type Language } from './generated/i18n-meta.ts'

const COUNTRY_LANGUAGE_MAP: Record<string, Language> = {
  FI: 'fi',
  SE: 'sv',
  ES: 'es',
  GB: 'en',
  US: 'en',
}

export function resolveLanguageFromCountry(countryCode: string | null): Language | null {
  if (!countryCode) {
    return null
  }

  return COUNTRY_LANGUAGE_MAP[countryCode.toUpperCase()] ?? null
}

export function resolveLanguageFromAcceptLanguage(
  acceptLanguageHeader: string | null
): Language | null {
  if (!acceptLanguageHeader) {
    return null
  }

  const entries = acceptLanguageHeader
    .split(',')
    .map((entry) => {
      const [locale, qualityString] = entry.trim().split(';q=')
      const quality = qualityString ? Number.parseFloat(qualityString) : 1
      return { locale: locale.trim(), quality }
    })
    .sort((first, second) => second.quality - first.quality)

  for (const { locale } of entries) {
    const primaryLanguage = locale.split('-')[0]?.toLowerCase()

    if (primaryLanguage && languages.includes(primaryLanguage as Language)) {
      return primaryLanguage as Language
    }
  }

  return null
}
